// extracted by mini-css-extract-plugin
module.exports = {"directoryImage":"Teleport_directoryImage__2DXEz","teleportImage":"Teleport_teleportImage__1-1h4","closeDiv":"Teleport_closeDiv__18-aq"};